import revive_payload_client_4sVQNw7RlN from "/build/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/build/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/build/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import siteConfig_Eeyr9ytLpT from "/build/node_modules/nuxt-site-config/dist/runtime/plugins/siteConfig.mjs";
import plugin_vue3_A0OWXRrUgq from "/build/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/build/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/build/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/build/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/build/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/build/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import gtm_client_OzmBuHLRIb from "/build/plugins/gtm.client.ts";
import tracking_client_0HR1cQSG9M from "/build/plugins/tracking.client.ts";
import webVitals_client_rMA3vEnjdM from "/build/plugins/webVitals.client.ts";
import sentry_client_shVUlIjFLk from "/build/plugins/sentry.client.ts";
import googleMaps_client_0BilS3KvAb from "/build/plugins/googleMaps.client.ts";
import inView_client_EA3JY3woHP from "/build/plugins/inView.client.ts";
import userAgentLookup_client_dJVerwLTLk from "/build/plugins/userAgentLookup.client.ts";
import cypress_client_6dhyhH346N from "/build/plugins/cypress.client.ts";
import index_m1ie4Ps7cH from "/build/plugins/services/index.ts";
import brandRoutes_NWEdenFxUP from "/build/plugins/brandRoutes.ts";
import handleError_Lcl5ShZoeF from "/build/plugins/handleError.ts";
import missingChunk_client_fBaeYVVBOP from "/build/plugins/missingChunk.client.ts";
import overlay_client_qg9tpZR1Mc from "/build/plugins/overlay.client.ts";
import resizeIframe_client_xcaAdRfny1 from "/build/plugins/resizeIframe.client.ts";
import runtimeLinks_client_i4mUi6AqlB from "/build/plugins/runtimeLinks.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  siteConfig_Eeyr9ytLpT,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  gtm_client_OzmBuHLRIb,
  tracking_client_0HR1cQSG9M,
  webVitals_client_rMA3vEnjdM,
  sentry_client_shVUlIjFLk,
  googleMaps_client_0BilS3KvAb,
  inView_client_EA3JY3woHP,
  userAgentLookup_client_dJVerwLTLk,
  cypress_client_6dhyhH346N,
  index_m1ie4Ps7cH,
  brandRoutes_NWEdenFxUP,
  handleError_Lcl5ShZoeF,
  missingChunk_client_fBaeYVVBOP,
  overlay_client_qg9tpZR1Mc,
  resizeIframe_client_xcaAdRfny1,
  runtimeLinks_client_i4mUi6AqlB
]